import { REWARD_CATEGORY } from '../actions/actionTypes';

const initialState = {};

const rewardCategory = (state = initialState, action) => {
  switch (action.type) {
    case REWARD_CATEGORY:
      state = action?.data;
      return state;
    default:
      return state;
  }
};

export default rewardCategory;
